import { useEffect } from 'react';
import { Button } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import './EmailVerified.less';
import { ReactComponent as Logo } from '../../assets/logo.svg';
import { useAuth0 } from '@auth0/auth0-react';
import {
  getStoredReferrerData,
  buildAuth0UTMParams,
} from '../../utils/utmTracking';

const EmailVerified = () => {
  const { loginWithRedirect } = useAuth0();

  // Get UTM data from localStorage
  const signupData = getStoredReferrerData();

  // Enable scrolling for this page (override global overflow: hidden)
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'auto';

    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  const handleContinueToLogin = () => {
    // Clear query parameters from URL before redirect
    window.history.replaceState({}, document.title, window.location.pathname);

    // Force a fresh login to ensure the correct user gets authenticated
    loginWithRedirect({
      authorizationParams: {
        prompt: 'login', // Force fresh login - shows Auth0 login page
        // Pass UTM and referrer data to Auth0 for tracking in Actions
        ...buildAuth0UTMParams(signupData),
      },
      appState: {
        returnTo: '/',
        // Preserve signup attribution if available
        ...(signupData
          ? {
              signup_attribution: {
                ...signupData,
                landing_page: window.location.href,
                timestamp: new Date().toISOString(),
              },
            }
          : {}),
      },
    });
  };

  return (
    <div id="email-verified-container">
      <div className="email-verified-icon">
        <Logo />
        <CheckCircleOutlined className="success-icon" />
      </div>
      <h1>Email Verified Successfully!</h1>
      <p className="success-message">
        Your email address has been verified and your account is now active.
      </p>
      <p className="next-step">
        Click the button below to log in and start using your account.
      </p>
      <Button
        type="primary"
        size="large"
        onClick={handleContinueToLogin}
        className="login-button"
      >
        Continue to Login
      </Button>
    </div>
  );
};

export default EmailVerified;
